import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';

export const fetchNotificationRecipientCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_NOTIFICATION_RECIPIENT_COUNT_SUCCESS',
    payload
  } as const);

export const fetchNotificationRecipientCount = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const { Equals } = OdataComparator;
    const odataParams = new QueryBuilder()
      .top(0)
      .filter(f => f.filterBy('isRead', Equals, false))
      .toQueryParam();

    const { data } = await axios.get<{ '@odata.count': number }>('/api/v3.01/notificationRecipients', {
      params: {
        ...odataParams,
        type: 'Organization',
        typeId: organizationId,
        notificationDomainType: 'SubcontractorManagement'
      }
    });

    dispatch(fetchNotificationRecipientCountSuccess(data['@odata.count']));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchNotificationRecipientCountSuccess>;
